import { useTranslation } from 'react-i18next';
import Iconify from 'src/components/Iconify';
import { MKT_POSTS_DESIGN as d } from '../MktPosts.design';

export default function PublishScopeBanner({ capabilities, onReconnect }) {
    const { t } = useTranslation('marketing');

    if (!capabilities || !capabilities.needsReconnect) return null;

    const affected = (capabilities.accounts || []).filter((a) => !a.canPublish);
    const title = affected.length === 1
        ? t('posts.scope.readOnlySingle', { name: affected[0].account_name })
        : t('posts.scope.readOnlyMultiple');

    return (
        <div className={d.capabilityBanner.container}>
            <Iconify icon="eva:alert-triangle-outline" width={20} className={d.capabilityBanner.icon} />
            <div className="flex-1 min-w-0">
                <p className={d.capabilityBanner.title}>{title}</p>
                <p className={d.capabilityBanner.subtitle}>
                    {t('posts.scope.reconnectBanner')}
                </p>
            </div>
            <span className={d.capabilityBanner.action} onClick={onReconnect}>
                {t('posts.scope.reconnectAccount')}
            </span>
        </div>
    );
}
